<app-metadata-view
  placement="bottom"
  [ngbTooltip]="fullDate"
  [keepOnHover]="true"
  [darkText]="true"
  [metadataDescriptionTranslationKey]="descriptionTranslationKey"
  [metadataValue]="resolveDisplayedDateMessage() | translate: { amount: amount }"
></app-metadata-view>

<ng-template #fullDate>
  <span>{{ tooltipDate }}</span>
</ng-template>
